import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAuth } from '../../auth/AuthContext'
import FairDatesManager from '../../components/fair/FairDatesManager'

// Operational tool — office managers do most of this work (admins too): check each
// fair's website and keep the important dates current. Office managers only see
// fairs students are actually competing in; admins can also see the rest.
export default function FairDatesPage() {
  const { role } = useAuth()
  const officeManager = role === 'office_manager'

  return (
    <Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: 1000 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>Fair Important Dates</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Check each fair's website and keep its key dates current — students and parents see these on
        their dashboards. Fairs are sorted by how many students are competing in them.
      </Typography>
      <FairDatesManager lockActiveOnly={officeManager} />
    </Box>
  )
}
